import { getDateFnsLocale } from "@tellescope/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useDateFnsLocale = () => {
  const { i18n } = useTranslation();
  const localeString = i18n.language;
  return useMemo(() => {
    return getDateFnsLocale(localeString);
  }, [localeString]);
};
